import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path d='M7 10V4H17V10' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M7 17H5.6C5.17565 17 4.76869 16.8361 4.46863 16.5444C4.16857 16.2527 4 15.857 4 15.4444V11.5556C4 11.143 4.16857 10.7473 4.46863 10.4556C4.76869 10.1639 5.17565 10 5.6 10H18.4C18.8243 10 19.2313 10.1639 19.5314 10.4556C19.8314 10.7473 20 11.143 20 11.5556V15.4444C20 15.857 19.8314 16.2527 19.5314 16.5444C19.2313 16.8361 18.8243 17 18.4 17H17'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M17 14H7V20H17V14Z' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
});

export default React.memo(Icon);
